import script from "./goRinSyo0074.vue?vue&type=script&setup=true&lang=js"
export * from "./goRinSyo0074.vue?vue&type=script&setup=true&lang=js"

import "./goRinSyo0074.vue?vue&type=style&index=0&id=12aad07f&lang=scss"

const __exports__ = script;

export default __exports__